<!-- TimelineContainer -->
<template lang="html">
  <div id="timelineContainer"
    :style="getContainerStyle"
    @keydown.esc.capture="stopDragging()"
    @dragover="dragoverHandler($event)"
    @drop.capture="dropHandler($event)">
    <div class="tlTicksCells"
    v-for="(tick, index) in $store.state.timeScaleTicks"
    :class="getTicksClass(index)"
    :style="tlTicksStyle">
    </div>
    <timeline v-for="classroom in classroomNames"
      :key="classroom"
      :classroom="classroom"
      :dragging="hasDraggingTl"
      @tlmousedown="mousedownHandler"
      @tlmousemove="mousemoveHandler"
      @tlmouseup="mouseupHandler"
     ></timeline>
     <reservation-box v-for="r in filteredreservation"
     :key="r.id"
     :reservation="r"
     @pvmousedown="mousedownHandler"
     @pvmousemove="mousemoveHandler"
     ></reservation-box>
     <preview-box
      :dragging="hasDraggingTl"
      @pvmousedown="mousedownHandler"
      @pvmousemove="mousemoveHandler"
      @pvmouseup="mouseupHandler"
      @keyup.esc="stopDragging()"></preview-box>
      <reservation-popup v-if="$store.state.previewBox.isPopupShown &&
      $store.state.previewBox.style.height !== 0"></reservation-popup>
      <editing-box></editing-box>
      <editing-popup></editing-popup>
      <information-popup></information-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  PREVIEWBOX_TIME_UPDATE,
  PREVIEWBOX_SHOW_POPUP,
  PREVIEWBOX_HIDE_POPUP,
  PREVIEWBOX_CLASSROOM_UPDATE,
  EDITINGBOX_CLASSROOM_UPDATE,
  EDITINGBOX_TIME_UPDATE
} from '@/vuex/mutation_types'

import T from '@/modules/time'

import Timeline from './Timeline'
import PreviewBox from './PreviewBox'
import ReservationPopup from './ReservationPopup'
import ReservationBox from './ReservationBox'
import EditingBox from './EditingBox'
import EditingPopup from './EditingPopup'
import InformationPopup from './InformationPopup'
import ClassroomConstants from '@/constants/ClassroomConstants'
export default {
  name: 'timeline-container',
  components: {
    'timeline': Timeline,
    'preview-box': PreviewBox,
    'reservation-popup': ReservationPopup,
    'reservation-box': ReservationBox,
    'editing-box': EditingBox,
    'editing-popup': EditingPopup,
    'information-popup': InformationPopup
  },
  data () {
    return {
      tlTicksStyle: {
        height: this.$store.state.rowHeight + 'px'
      },
      hasDraggingTl: false,     // ドラッグ中のTLがある
      focusedClassroom: '',     // 現在ドラッグしてる教室
      dragStartTime: new T('00:00'), // ドラッグ開始した位置が表す時刻
      dragEndTime: new T('00:00'), // ドラッグ中または終了した位置が表す時刻
      mousedownTime: 0,         // マウスダウンしてからの時間
      clickthreshold: 200,      // マウスダウンとクリックとの境界線(ミリ秒)
      isFuture: true,           // 選択された時刻が現在より未来かどうか
      isBeforeDeadline: true  // 選択された時刻が締め切り（前日の22時）より前かどうか
    }
  },
  methods: {
  // 目盛りを表示するdiv要素のクラスを決定する。
    getTicksClass (index) {
      if (index === 0) {
        return 'tickTop'
      } else if (index % 2 === 0) {
        return 'ticksMain'
      } else {
        return 'ticksSub'
      }
    },
    clickHandler (argobj) {
      // 閲覧者は予約不能に
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return
      }
      // 予備教室は管理者以外予約不可
      if (this.$store.state.userInfo.user_type !== 'admin' &&
          ClassroomConstants.spareRooms.indexOf(argobj.classroom) !== -1) {
        return
      }
      // 操作権限を管理者のみに （公開日まで)
      // if (this.$store.state.userInfo.user_type !== 'admin') {
      //   return
      // }
      if (this.$store.state.previewBox.isPopupShown) {
        this.$store.commit(
          PREVIEWBOX_HIDE_POPUP
        )
        this.$store.commit(
          PREVIEWBOX_TIME_UPDATE,
          {
            start: '10:00',
            end: '10:00'
          }
        )
      }
      this.$store.commit(
        PREVIEWBOX_CLASSROOM_UPDATE,
        argobj.classroom
      )
      let nearestTime = this.fitToNearDivTime(
        this.positionToTime(argobj.e.offsetY)
        )
      this.$store.commit(
        PREVIEWBOX_TIME_UPDATE,
        {
          start: nearestTime.toString(),
          end: nearestTime.addMinuites(60).toString()
        }
      )
      this.$store.commit(
        PREVIEWBOX_SHOW_POPUP
      )
      // 講義情報改めて取得
      if (this.$store.state.lectureInfo.length === 0) {
        this.$store.dispatch('getLectures', {})
      }
    },
    mousedownHandler (argobj) {
      // 閲覧者は予約不能に
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return
      }
      // 予備席は管理者以外予約不可
      if (this.$store.state.userInfo.user_type !== 'admin' &&
          ClassroomConstants.spareRooms.indexOf(argobj.classroom) !== -1) {
        alert('予備席には予約できません')
        return
      }
      // 操作権限を管理者のみに TODO:本実装までの応急処置
      if (this.$store.state.userInfo.user_type !== 'admin' && !this.isAfterRelease) {
        return
      }
      if (this.$store.state.previewBox.isPopupShown) {
        this.$store.commit(
          PREVIEWBOX_HIDE_POPUP
        )
        this.$store.commit(
          PREVIEWBOX_TIME_UPDATE,
          {
            start: '10:00',
            end: '10:00'
          }
        )
        this.dragStartTime = new T('00:00')
      }
      // 現在時刻とクリックされた部分の時刻を比較してisFutureを更新し，falseだったら警告を出して終了
      this.mousedownTime = new Date().getTime()
      let nearestTime = this.fitToNearDivTime(
        this.positionToTime(argobj.e.offsetY)
        )
      let clickedTime = new Date(this.$store.state.curDate.getFullYear(), this.$store.state.curDate.getMonth(), this.$store.state.curDate.getDate(), nearestTime.getMinutes() / 60, nearestTime.getMinutes() % 60)
      this.isFuture = clickedTime.getTime() > this.mousedownTime
      if (!this.isFuture && this.$store.state.userInfo.user_type !== 'admin') {
        alert('過去への予約は出来ません')
        return
      }
      // isBeforeDeadlineを更新し，falseだったら警告を出して終了
      let now = new Date()
      let dateDiff = (new Date(clickedTime.getFullYear(), clickedTime.getMonth(), clickedTime.getDate()) -
                        new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 1000 / 60 / 60 / 24
      this.isBeforeDeadLine = (clickedTime.getDay() === 1 && (dateDiff > 2 || (dateDiff === 2 && now.getHours() < 22))) ||   // 指定時刻が月曜日の場合
                              (clickedTime.getDay() !== 1 && (dateDiff > 1 || (dateDiff === 1 && now.getHours() < 22)))     // 月曜日以外の場合
      if (!this.isBeforeDeadLine && this.$store.state.userInfo.user_type !== 'admin') {
        alert('指定された時刻への予約は締め切られました')
        return
      }
      this.dragStartTime = nearestTime
      this.hasDraggingTl = true
      this.$store.commit(
        PREVIEWBOX_CLASSROOM_UPDATE,
        argobj.classroom
      )
      this.$store.commit(
        PREVIEWBOX_TIME_UPDATE,
        {
          start: this.dragStartTime.toString(),
          end: this.dragEndTime.toString()
        }
      )
    },
    mousemoveHandler (argobj) {
      // 閲覧者は予約不能に
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return
      }
      // 予備教室は管理者以外予約不可
      if (this.$store.state.userInfo.user_type !== 'admin' &&
          ClassroomConstants.spareRooms.indexOf(argobj.classroom) !== -1) {
        return
      }
      if (this.hasDraggingTl && (this.$store.state.userInfo.user_type === 'admin' || this.isFuture) && this.isBeforeDeadline) {
        // 22:00 以降にドラッグが及ばないように
        if (this.timelineHeight - (this.$store.state.rowHeight) < argobj.e.offsetY) {
          argobj.e.offsetY = this.timelineHeight - (this.$store.state.rowHeight)
        }

        this.dragEndTime = this.fitToNearDivTime(
          this.positionToTime(argobj.e.offsetY)
        )
        if (this.isReversed()) {
          this.$store.commit(
            PREVIEWBOX_TIME_UPDATE,
            {
              start: this.dragEndTime.toString(),
              end: this.dragStartTime.toString()
            }
          )
          return
        } else {
          this.$store.commit(
            PREVIEWBOX_TIME_UPDATE,
            {
              end: this.dragEndTime.toString()
            }
          )
        }
      }
    },
    mouseupHandler (argobj) {
      // 閲覧者は予約不能に
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return
      }
      // 操作権限を管理者のみに TODO:本実装までの応急処置
      if (this.$store.state.userInfo.user_type !== 'admin' && !this.isAfterRelease) {
        return
      }
      if ((!this.isFuture || !this.isBeforeDeadline) && this.$store.state.userInfo.user_type !== 'admin') {
        return
      }
      let mouseDownSpan = (new Date().getTime()) - this.mousedownTime
      if (mouseDownSpan < this.clickthreshold) {
        this.clickHandler(argobj)
        this.mousedownTime = undefined
        this.hasDraggingTl = false
        return
      }
      this.hasDraggingTl = false
      let dragEndTime = this.fitToNearDivTime(
        this.positionToTime(argobj.e.offsetY)
      )
      // 現在時刻とマウスが離された部分の時刻を比較し，現在よりも過去だったらpreview boxを削除して終了
      let nowTime = new Date().getTime()
      let mouseUpTime = new Date(this.getCurDateFormated + ' ' + dragEndTime.toString()).getTime()
      if (mouseUpTime < nowTime && this.$store.state.userInfo.user_type !== 'admin') {
        this.$store.commit(PREVIEWBOX_TIME_UPDATE, { start: '10:00', end: '10:00' })
        return
      }
      this.$store.commit(PREVIEWBOX_SHOW_POPUP)

      if (this.isReversed()) {
        this.$store.commit(
          PREVIEWBOX_TIME_UPDATE,
          {
            start: dragEndTime.toString()
          }
        )
      } else {
        this.$store.commit(
          PREVIEWBOX_TIME_UPDATE,
          {
            end: dragEndTime.toString()
          }
        )
      }
      // 講義情報改めて取得
      if (this.$store.state.lectureInfo.length === 0) {
        this.$store.dispatch('getLectures', {})
      }
    },
    stopDragging () {
      // 閲覧者は予約不能に
      if (this.$store.state.userInfo.user_type === 'viewer') {
        return
      }
      this.hasDraggingTl = false
      if (this.$store.state.previewBox.isPopupShown) {
        this.$store.commit(
          PREVIEWBOX_HIDE_POPUP
        )
        this.$store.commit(
          PREVIEWBOX_TIME_UPDATE,
          {
            start: '10:00',
            end: '10:00'
          }
        )
        this.dragStartTime = new T('00:00')
      }
    },
    dragoverHandler (e) {
      e.preventDefault()
    },
    dropHandler (e) {
      e.preventDefault()
      let clrect = this.$el.getBoundingClientRect()
      let offsets = JSON.parse(e.dataTransfer.getData('text/json'))
      let top = e.pageY - clrect.top - window.pageYOffset - offsets.y
      let start = this.fitToNearDivTime(this.positionToTime(top)).toString()
      let span = (new T(this.$store.state.editingState.end)).getMinutes() -
       (new T(this.$store.state.editingState.start)).getMinutes()
      let end = this.fitToNearDivTime(this.positionToTime(top)).addMinuites(span).toString()

      this.$store.commit(EDITINGBOX_TIME_UPDATE, {
        start: start,
        end: end
      })
      this.$store.commit(EDITINGBOX_CLASSROOM_UPDATE, this.getClassroomAt(e.pageX - clrect.left - window.pageXOffset))
    },
    escHandler (event) {
      this.hasDraggingTl = false
    },
    isReversed () {
      if (this.dragEndTime.getMinutes() < this.dragStartTime.getMinutes()) {
        return true
      }
      return false
    },
    isOver2200 (t) {
      if (t.getMinutes() > new T('22:00').getMinutes()) {
        return true
      }
      return false
    }
  },
  computed: {
    ...mapGetters([
      'timelinesWidth',
      'timelineHeight',
      'fitToNearDivTime',
      'timeToPosition',
      'positionToTime',
      'getClassroomAt',
      'getCurDateFormated',
      'getLeftPosOfClassroom',
      'classroomNames'
    ]),
    getContainerStyle () {
      let style = {
        width: this.timelinesWidth + 'px',
        height: this.timelineHeight + 'px'
      }

      if (this.$window.scrollX > 0 && this.$window.scrollY > 0) {
        style.position = 'absolute'
        style.left = this.$store.state.rulerWidth + 'px'
        style.top = this.$store.state.tbHeaderHeight +
        this.$store.state.headerHeight + 2 + 'px'
      } else if (this.$window.scrollX > 0) {
        style.position = 'absolute'
        style.left = this.$store.state.rulerWidth + 'px'
      } else if (this.$window.scrollY > 0) {
        style.position = 'relative'
        style.top = this.$store.state.tbHeaderHeight + 'px'
      } else {
      }
      return style
    },
    isAfterRelease () { // 公開日(2017-11-20 14:00) 以降かどうか TODO:後に削除する
      let theday = new Date(2017, 10, 20, 14, 0, 0)
      let now = new Date()
      return now.getTime() > theday.getTime()
    },
    filteredreservation () {
      if (this.$store.state.userInfo.user_type !== 'admin' && this.$store.state.userInfo.user_id !== 18 && this.$store.state.userInfo.user_type !== 'viewer') {
        if (this.$store.state.reservations !== undefined) {
          this.$store.state.reservations = this.$store.state.reservations.filter(function (c) {
            return !c.classroom.match('301')
          })
        }
        // return this.$store.state.reservations
      }
      console.log(this.$store.state.reservations)
      if (this.$store.state.showOnline) {
        this.$store.state.reservations = this.$store.state.reservations.filter(function (c) {
          return c.classroom.match(/^オンライン/)
        })
      } else {
        this.$store.state.reservations = this.$store.state.reservations.filter(function (c) {
          return !c.classroom.match(/^オンライン/)
        })
      }
      console.log(this.$store.state.reservations)
      return this.$store.state.reservations
    }
  }
}
</script>

<style lang="css">
#timelineContainer {
  position: relative;
  background-color: white;
  z-index: 1000;

  border-right: solid 2px;
  border-bottom: solid 2px;

  /* ユーザーによるドラッグ選択を拒否（ドラッグ機能に対する保護） */
  user-select: none; /* CSS3 */
  -moz-user-select: none; /* Firefox */
  -webkit-user-select: none; /* Safari、Chromeなど */
  -ms-user-select: none; /* IE10かららしい */
}
.tlTicksCells {
  box-sizing: border-box;
  opacity: 0.5;
}

</style>



// WEBPACK FOOTER //
// TimelineContainer.vue?123305d1